import React from 'react';
import type { SVGPropsWithClassName } from './types';
import { colors } from '@/styles';
import { isColorName } from '@/styles/colorUtils';

export const Replay = ({
  className = '',
  size = 16,
  title = 'Replay',
  fill = colors.silverSandAlt,
}: SVGPropsWithClassName) => {
  const height = Number(size) * 2.85;

  let svgFill = fill;
  if (isColorName(fill)) {
    console.warn('Using deprecated fill prop for Replay svg, fill should be a hex.');
    svgFill = colors[fill];
  }

  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      height={height}
      viewBox="0 0 25.5 30"
    >
      {Boolean(title) && <title>{title}</title>}
      <path
        d={`
M25,13.66A12.45,12.45,0,0,0,13.05,4.52h-.28l3-3.11L14.23,
0,8.53,5.66l6.74,5.39,1.29-1.69L13,6.61A10.62,10.62,0,1,
1,6.06,9l.38-.3L4.83,7.26l-.1.09A12.75,12.75,0,1,0,25,13.67Z
`}
        fill={svgFill}
      />
    </svg>
  );
};
